const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#185e4c',
                hover: '#114b3c'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
